import { render } from "./SimulationInputsPage.vue?vue&type=template&id=5a328b96&scoped=true"
import script from "./SimulationInputsPage.vue?vue&type=script&lang=js"
export * from "./SimulationInputsPage.vue?vue&type=script&lang=js"

import "./SimulationInputsPage.vue?vue&type=style&index=0&id=5a328b96&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a328b96"]])

export default __exports__